import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import {Grid, Row, Col} from 'react-bootstrap'
import i18n from '../i18n'
import Icon from './Icon'
import style from './SearchBar.less'

class SearchBar extends Component {
    static propTypes = {
        size: PropTypes.string,
        footer: PropTypes.object,
        onOpen: PropTypes.func,
        onClose: PropTypes.func
    }

    static defaultProps = {
        onOpen: () => {},
        onClose: () => {},
    }

    constructor(props) {
        super(props)

        this.state = {
            opened: false,
            searched: false
        }
    }

    _toggle(event) {
        const {onOpen, onClose} = this.props
        const {opened} = this.state

        event.preventDefault()
        this.setState({opened: !opened})

        if (opened) {
            onClose()
        } else {
            onOpen()
        }
    }

    _click(event) {
        const {onClick, value} = this.props

        event.preventDefault()

        if (onClick) {
            Promise.resolve(onClick(event)).then(() => {
                this.setState({searched: !!value})
            })
        }
    }

    _keyPress(event) {
        const {onKeyPress, value} = this.props

        if (onKeyPress && event.key == 'Enter') {
            Promise.resolve(onKeyPress(event)).then(() => {
                this.setState({searched: !!value})
            })
        }
    }

    _change(event) {
        const {onChange} = this.props

        if (onChange) {
            onChange(event)
            this.setState({searched: false})
        }
    }

    _clear(event) {
        const {onClick, onChange} = this.props

        event.preventDefault()

        if (onClick && onChange) {
            onChange(null)
            setTimeout(() => {
                // wait parent component receives new props
                Promise.resolve(onClick()).then(() => {
                    this.setState({searched: false})
                })
            }, 0)
        }
    }

    render() {
        const {children, size, footer, onOpen, onClose, onClick, onChange, onKeyPress, ...other} = this.props
        const {opened, searched} = this.state
        const sizeClass = size && size.toLowerCase()

        const transitionName = {
            enter: style.enter,
            enterActive: style.enterActive,
            leave: style.leave,
            leaveActive: style.leaveActive
        }

        return (
            <div className={cx(style.default, style[sizeClass])}>
                <div className={style.header}>
                    <Grid>
                        {children && (
                            <div className={style.advance}>
                                <div className={style.advanceContent}>
                                    <a
                                        href=''
                                        onClick={(e) => this._toggle(e)}>
                                        {i18n.advancedSearch}
                                        <Icon
                                            icon={opened && 'up' || 'down'}
                                            size='sm' />
                                    </a>
                                </div>
                            </div>
                        )}
                        <div className={style.search}>
                            {searched && (
                                <a
                                    href=''
                                    onClick={(e) => this._clear(e)}>
                                    <Icon
                                        icon='cross'
                                        size='md'
                                        active={sizeClass != 'small'} />
                                </a>
                            )}
                            {!searched && (
                                <a
                                    href=''
                                    onClick={(e) => this._click(e)}>
                                    <Icon
                                        icon='search'
                                        size='md'
                                        active={sizeClass != 'small'} />
                                </a>
                            )}
                        	<div className={style.container}>
                                <input
                                    type='text'
                                    onChange={(e) => this._change(e)}
                                    onKeyPress={(e) => this._keyPress(e)}
                                    {...other} />
                            </div>
                        </div>
                    </Grid>
                </div>
                {children && (
                    <ReactCSSTransitionGroup
                        transitionName={transitionName}
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={500}>
                        {opened && (
                            <div className={style.body}>
                                <Grid>
                                    <div className={style.container}>
                                        {children}
                                    </div>
                                </Grid>
                            </div>
                        )}
                    </ReactCSSTransitionGroup>
                )}
                {footer && (
                    <div className={style.footer}>
                        <Grid>
                            <div className={style.container}>
                                {footer}
                            </div>
                        </Grid>
                    </div>
                )}
            </div>
        )
    }
}

export default SearchBar


// WEBPACK FOOTER //
// ./lib/core/components/SearchBar.js